const STORAGE_KEY = 'lesson-not-passed-hint-suppressed';

export function isLessonNotPassedHintSuppressed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setLessonNotPassedHintSuppressed(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* ignore quota / private mode */
  }
}
